import { z } from 'zod';
import { defineEndpoint } from '../define';
import { RequiredArtifactSchema } from './shapes';

export const putRequiredArtifacts = defineEndpoint({
  method: 'PATCH',
  path: '/v1/release-products/:productId/required-artifacts',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({ environment: z.enum(['dev', 'sit', 'uat', 'prd']) }),
  body: z.object({ items: z.array(RequiredArtifactSchema).max(20) }),
  response: z.object({ data: z.array(RequiredArtifactSchema) }),
});
